const it = {
  metaTitle: "FearGreed — Pulsante Sentiment Crypto",
  metaDescription: "Il Crypto Fear & Greed Index come un singolo pulsante tattile. Aggiornamenti programmati da alternative.me. Nessun account, nessun tracciamento.",

  navAbout: "Docs",
  footerPrivacy: "Privacy",
  footerSupport: "Supporto",
  footerAbout: "Docs",
  footerDataSource: "Dati: alternative.me · Non è consulenza finanziaria",

  loading: "Caricamento…",
  unableToLoad: "Impossibile caricare l'indice",
  somethingWentWrong: "Qualcosa è andato storto.",
  tryAgain: "Riprova",
  lastUpdated: "Aggiornato {time}",
  updating: "Aggiornamento…",
  buttonUpdated: "Aggiornato ✓",
  nowLabel: "{value} ({bucket})",
  sourceLabel: "Fonte: alternative.me",
  ariaButton: "{value} {bucket} — Indice Fear and Greed. Tocca per un insight.",

  ritualDisclaimer: "Non è consulenza finanziaria",

  infoTitle: "Indice Fear & Greed",
  infoDescription: "Punteggio di sentiment del mercato crypto (0–100). Volatilità, momentum, social, sondaggi. Fonte: alternative.me. Non è consulenza finanziaria.",
  infoAttribution: "Dati da alternative.me Crypto Fear & Greed Index.",
  info7d: "Trend 7 giorni",
  info30d: "Trend 30 giorni",
  infoNextUpdate: "Prossimo aggiornamento",
  infoInterpretTitle: "Come leggere",
  infoInterpretExtremeFear: "0–24: Paura Estrema. Storicamente ha preceduto alcune riprese.",
  infoInterpretExtremeGreed: "75–100: Avidità Estrema. Storicamente ha preceduto alcune correzioni.",
  infoDisclaimer: "Solo indicatore di sentiment. I pattern passati non predicono risultati futuri. Fai le tue ricerche.",
  infoApiTitle: "API",
  infoPulseTitle: "Pulse",
  infoDocsLink: "Documentazione completa e riferimento API",

  backToButton: "Indietro",

  aboutTitle: "Docs",
  aboutWhatTitle: "Cos'è FearGreed?",
  aboutWhat: "Mostra il Crypto Fear & Greed Index — un punteggio giornaliero di sentiment (0–100) calcolato da alternative.me basato su volatilità, momentum, social media, sondaggi, dominanza e tendenze. Un segnale. Nessun rumore.",
  aboutWhyTitle: "Perché FearGreed?",
  aboutWhyIntro: "L'indice grezzo è un numero. FearGreed lo trasforma in un prodotto.",
  aboutWhy1Title: "UX ritualizzata",
  aboutWhy1: "Un pulsante tattile. Niente grafici, niente rumore, niente dashboard. Tocca, leggi, vai avanti.",
  aboutWhy2Title: "Sincronizzazione programmata",
  aboutWhy2: "Controlla nuovi dati tramite finestre cron programmate, allineate con il ciclo di aggiornamento giornaliero della fonte.",
  aboutWhy3Title: "Analisi derivate",
  aboutWhy3: "Delta, medie mobili, pendenza, durata del regime, etichette di sorveglianza — calcolati dai dati grezzi, non disponibili dalla fonte.",
  aboutWhy4Title: "Pulse in linguaggio naturale",
  aboutWhy4: "Frase di insight giornaliera generata dall'IA. Contestuale, non generica.",
  aboutWhy5Title: "Market tape",
  aboutWhy5: "Variazioni 24h BTC/ETH, capitalizzazione, dominanza, volume e etichetta di pressione. Aggiornato ogni 4 ore.",
  aboutWhy6Title: "Per agenti",
  aboutWhy6: "Endpoint JSON strutturati, llms.txt, specifica OpenAPI e badge SVG. Costruito per il consumo programmatico.",
  aboutSourceTitle: "Fonte dati",
  aboutSource: "Dati da alternative.me. La fonte si aggiorna tipicamente una volta al giorno intorno alle 00:00 UTC. FearGreed controlla i nuovi dati tramite finestre cron programmate allineate con questo programma.",
  aboutApiTitle: "API",
  aboutApiDescription: "Endpoint pubblici. CORS abilitato. JSON salvo diversa indicazione. Nessuna autenticazione richiesta.",
  aboutApiLatest: "Ultimo valore con analisi derivate: delta, medie, distanza dal neutrale.",
  aboutApiHistory: "Ultimi 30 valori giornalieri con bucket e colore.",
  aboutApiSummary: "Riassunto in testo semplice. Utile per LLM e agenti.",
  aboutApiBadge: "Badge SVG. Da inserire in README o dashboard.",
  aboutApiContext: "Contesto giornaliero generato dall'IA con suggerimento di tendenza e tutte le analisi derivate. Cache 1h.",
  aboutApiPulse: "Analisi strutturate: regime, segnale, pendenza, medie. Nessuna IA. Cache 15min.",
  aboutApiTape: "Variazioni 24h BTC/ETH, capitalizzazione, dominanza, volume e etichetta di pressione. Cache 30min.",
  aboutBadgeTitle: "Badge / Embed statico",
  aboutBadgeDescription: "Inserisci l'indice attuale come badge SVG:",
  aboutEmbedTitle: "Embed interattivo",
  aboutEmbedDescription: "Inserisci il pulsante interattivo completo in qualsiasi pagina tramite iframe. Stessa sensazione tattile, senza chrome, solo dati in cache.",
  aboutCurlTitle: "Esempio di richiesta",
  aboutJsonExample: "Esempio di risposta (Latest)",
  aboutLlmsTxtTitle: "llms.txt",
  aboutLlmsTxtDescription: "Riassunto del progetto leggibile dalle macchine per agenti LLM e crawler.",
  aboutOpenapiTitle: "OpenAPI",
  aboutOpenapiDescription: "Specifica API completa in formato OpenAPI 3.0.",
  aboutDisclaimerTitle: "Avvertenza",
  aboutDisclaimer: "Solo utilità di sentiment. Non prevede movimenti di prezzo. Non è consulenza finanziaria. Fai le tue ricerche.",
  aboutNonAffiliation: "FearGreed è un'interfaccia indipendente. Non è affiliato né approvato da alternative.me.",
  staleIndicator: "Offline · dati in cache",
  infoButton: "Più informazioni",
  languageSelector: "Lingua",
  themeToggle: "Cambia tema",

  privacyTitle: "Informativa sulla privacy",
  privacyEffectiveDate: "Data di decorrenza: 8 marzo 2026",
  privacySummaryTitle: "Riepilogo",
  privacySummary: "FearGreed non richiede login, non crea account e non raccoglie dati personali.",
  privacyDataTitle: "Dati raccolti",
  privacyData: "Nessuno. Nessuna registrazione, nessun cookie di tracciamento, nessun profilo analitico.",
  privacyTechTitle: "Dati tecnici",
  privacyTech: "L'infrastruttura di hosting può registrare indirizzi IP e timestamp per affidabilità. Non collegati a singoli utenti.",
  privacyThirdPartyTitle: "Servizi di terze parti",
  privacyThirdParty: "FearGreed recupera dati dall'API alternative.me. Consulta la loro informativa sulla privacy.",
  privacyAdsTitle: "Pubblicità",
  privacyAds: "FearGreed non mostra pubblicità.",
  privacyChangesTitle: "Modifiche",
  privacyChanges: "Gli aggiornamenti saranno pubblicati su questa pagina con una data di decorrenza aggiornata.",
  privacyContactTitle: "Contatti",
  privacyContact: "Domande? Contattaci a",

  supportTitle: "Supporto",
  supportDescription: "Per domande o problemi, contattaci a:",

  bucketExtremeFear: "Paura Estrema",
  bucketFear: "Paura",
  bucketNeutral: "Neutrale",
  bucketGreed: "Avidità",
  bucketExtremeGreed: "Avidità Estrema",

  pulseLabel: "Pulse:",
  regimeSuffix: "regime {days}g",
  watchFearDeepening: "Paura in Aumento",
  watchFearStabilizing: "Paura in Stabilizzazione",
  watchNeutralCompression: "Compressione Neutrale",
  watchGreedAccelerating: "Avidità in Accelerazione",
  watchGreedOverheating: "Avidità in Surriscaldamento",
  watchPossibleReversal: "Possibile Inversione",
  watchTrendPersistence: "Trend Persistente",
  watchRecoveryBuilding: "Ripresa in Costruzione",

  infoRegimePulse: "Regime e Pulse",
  infoMarketTape: "Market Tape",
  infoPressure: "Pressione",

  updateAvailable: "Aggiornamento disponibile",

  aboutViewLlmsTxt: "Visualizza llms.txt",
  aboutViewOpenapi: "Visualizza openapi.json",

  // Market pressure labels
  pressureBroadSellOff: "Vendita massiccia",
  pressureUnderPressure: "Sotto pressione",
  pressureBroadRally: "Rally generalizzato",
  pressureRiskAppetite: "Propensione al rischio in aumento",
  pressureFlat: "Mercato piatto",
  pressureMixed: "Segnali misti",

  notFoundTitle: "Pagina non trovata",
  notFoundBack: "Torna alla Home",

  hintTap: "premi qui",
} as const;

export default it;
